import React from "react";
// import inputTypes from "../../data/fetchInputTypes"
// import AppLocale from "../lang";
import { NotificationManager } from "../../components/common/react-notifications";
import { cloneDeep } from 'lodash';
import _axios from '../../libs/axios';

export default (context) => {
  const M = "admFlowInput."

  // Add reorder functions to context
  context.moveFlowInput = function (item, direction) {
    let data = cloneDeep(this.state.data)
    let index = data.findIndex(e => e.ID === item.ID)
    
    if (direction === 'up') {
      if (index === 0) return NotificationManager.error("Cannot move item higher", "Cannot move", 3000, null, null, 'outline')
      
      // Get the two items to swap
      const currentItem = data[index]
      const previousItem = data[index - 1]
      
      // Call server to swap order
      this.props.setLoader(true)
      _axios
        .post('admFetchInput/swapOrder', {
          item1Id: currentItem.ID,
          item2Id: previousItem.ID,
          item1Order: currentItem.order,
          item2Order: previousItem.order
        })
        .then(r => {
          this.props.setLoader(false)
          if (r.status >= 0) {
            // Update order locally
            data[index].order = previousItem.order
            data[index - 1].order = currentItem.order
            
            // Swap items in the array
            const temp = data[index]
            data[index] = data[index - 1]
            data[index - 1] = temp
            
            // Update state with new order
            this.setState({ data: data })
            NotificationManager.success(r.msg, "", 5000, null, null, 'outline')
          } else {
            NotificationManager.error(r.msg, "Error", 5000, null, null, 'outline')
          }
        })
        .catch((e) => { 
          this.props.setLoader(false)
          NotificationManager.error("Network error", "Error", 5000, null, null, 'outline')
        })
    }
    
    if (direction === 'down') {
      if (index === data.length - 1) return NotificationManager.error("Cannot move item lower", "Cannot move", 3000, null, null, 'outline')
      
      // Get the two items to swap
      const currentItem = data[index]
      const nextItem = data[index + 1]
      
      // Call server to swap order
      this.props.setLoader(true)
      _axios
        .post('admFetchInput/swapOrder', {
          item1Id: currentItem.ID,
          item2Id: nextItem.ID,
          item1Order: currentItem.order,
          item2Order: nextItem.order
        })
        .then(r => {
          this.props.setLoader(false)
          if (r.status >= 0) {
            // Update order locally
            data[index].order = nextItem.order
            data[index + 1].order = currentItem.order
            
            // Swap items in the array
            const temp = data[index]
            data[index] = data[index + 1]
            data[index + 1] = temp
            
            // Update state with new order
            this.setState({ data: data })
            NotificationManager.success(r.msg, "", 5000, null, null, 'outline')
          } else {
            NotificationManager.error(r.msg, "Error", 5000, null, null, 'outline')
          }
        })
        .catch((e) => { 
          this.props.setLoader(false)
          NotificationManager.error("Network error", "Error", 5000, null, null, 'outline')
        })
    }
  }

  return {
    config: {
      resource: "admFetchInput",
      pageSize: 100,
      hidePagination: true,
      list: false,
      name: `${M}questions`,
      remapRow: (form) => {
        return form
      },
      modal: {
        size: "lg"
      }
    },

    actions: {
      create: true,
      edit: true,
      delete: true,
      print: false,
      export: false,
      search: false
    },

    form: {
      remapOne: (r) => {
        if (r.status >= 0) {
          r.data.selectedType = r.data.type
          if (r.data.optional !== undefined) {
            r.data.required = !r.data.optional
            delete r.data.optional
          }
        }
        return r
      },
      setValuesBeforePost: (v) => {
        if (v.required !== undefined) {
          v.optional = !v.required
          delete v.required
        }
        delete v.flags
        delete v.selectedField
        return v
      },
      beforeOpenModal: () => {
        return new Promise((resolve) => {
          context.setState({modalPreview: false})
          resolve(true)
        })
      },
      fields: [
        {
          name: "fectchId",
          value: context?.props?.filterBy?.fetchId,
          type: "hidden",
        },
        {
          col: 12,
          name: "name",
          value: "",
          type: "text",
          label: `${M}question`,
          rules: "required|max:100",
          maxLength: "100",
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 12,
          name: "desc",
          value: "",
          type: "textarea",
          label: `main.desc`,
          rules: "required|max:255",
          maxLength: "255",
          opts: {
            style: 'float-label',
            rows: 2
          }
        },
        {
          col: 12,
          name: "selectedType",
          value: "",
          type: "text",
          rules: "required",
          rulesMessages: {messages: {required: 'admFlow.questionType'}},
          opts: {
            inputWrapperClassName: "d-none"
          }
        },
        {
          col: 12,
          name: "type",
          value: "",
          type: "radio",
          label:`${M}typeText`,
          opts: {
            value: "text",
            desc: `${M}descTypeText`,
          },
          onChange: ctx => ctx.setState({selectedType: ctx.state.type, options: ""})
        },
        {
          col: 12,
          name: "type",
          value: "",
          type: "radio",
          label:`main.date`,
          opts: {
            value: "date",
            desc: `main.date`
          },
          onChange: ctx => ctx.setState({selectedType: ctx.state.type, options: ""})
        },
        {
          col: 12,
          name: "type",
          value: "",
          type: "radio",
          label: `Document`,
          opts: {
            value: "document",
            desc: `Document`
          },
          onChange: ctx => ctx.setState({selectedType: ctx.state.type, options: ""})
        },
        {
          col: 12,
          name: "type",
          value: "",
          type: "radio",
          label:`${M}typeOption`,
          opts: {
            value: "option",
            desc: `${M}descTypeOption`
          },
          onChange: ctx => ctx.setState({selectedType: ctx.state.type, options: ""})
        },
        {
          col: 12,
          name: "type",
          value: "",
          type: "radio",
          label: `${M}typeMultiple`,
          opts: {
            value: "multiple",
            desc: `${M}descTypeMultiple`
          },
          onChange: ctx => ctx.setState({selectedType: ctx.state.type, options: ""})
        },
        {
          col: 12,
          name: "type",
          value: "",
          type: "radio",
          label: `${M}typeLocation`,
          opts: {
            value: "location",
            desc: `${M}descTypeLocation`
          },
          onChange: ctx => ctx.setState({selectedType: ctx.state.type, options: ""})
        },
        // {
        //   col: 12,
        //   name: "type",
        //   value: "",
        //   type: "radio",
        //   label: `${M}typeSignature`,
        //   opts: {
        //     value: "signature",
        //     desc: `${M}descTypeSignature`
        //   },
        //   onChange: ctx => ctx.setState({selectedType: ctx.state.type, options: ""})
        // },
        // {
        //   col: 12,
        //   name: "type",
        //   value: "",
        //   type: "radio",
        //   label: `${M}typeIdentity`,
        //   opts: {
        //     value: "kyc",
        //     desc: `${M}descTypeIdentity`
        //   },
        //   onChange: ctx => ctx.setState({selectedType: ctx.state.type, options: ""})
        // },
        // {
        //   col: 12,
        //   name: "type",
        //   value: "",
        //   type: "radio",
        //   label: `${M}typePayment`,
        //   opts: {
        //     value: "payment",
        //     desc: `${M}descTypePayment`
        //   },
        //   onChange: ctx => ctx.setState({selectedType: ctx.state.type, options: ""})
        // },
        {
          col: 12,
          name: "label1",
          value: (L) => `<h5>${L[`${M}addOption`]}</h5>`,
          type: "label",
          renderIf: ctx => ["option", "multiple"].indexOf(ctx.state.type) > -1
        },
        {
          col: 12,
          name: "options",
          value: "",
          type: "sortable",
          placeholder: `${M}optionPlaceholder`,
          rules: "required",
          opts: {
            nameButton: `${M}addAnswer`
          },
          renderIf: ctx => ["option", "multiple"].indexOf(ctx.state.type) > -1
        },
        {
          col: 12,
          name: "empty1",
          type: "separator"
        },
        {
          col: 4,
          name: "hidden",
          value: false,
          type: "switch",
          label: `main.hidden`,
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 4,
          name: "required",
          value: false,
          type: "switch",
          label: `main.required`,
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 4,
          name: "inactive",
          value: false,
          type: "switch",
          label: `main.inactive`,
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "apiMethod",
          value: null,
          type: "select",
          label: `admFlow.apiMethod`,
          opts: {
            style: 'float-label',
            items: [
              { value: null, label: "[none]" },
              { value: "GET", label: "GET" },
              { value: "POST", label: "POST" },
              { value: "POST", label: "PATCH" }
            ]
          }
        },
        {
          col: 6,
          name: "empty2",
          type: "separator"
        },
        {
          col: 12,
          name: "apiConfig",
          type: "collapsible",
          placeholder: 'Endpoint configuration',
          value: true,
          renderIf: ctx => ctx.state.apiMethod !== null && ctx.state.apiMethod !== "",
          childs: [
            {
              col: 12,
              name: "apiEndpoint",
              value: "",
              type: "text",
              label: `admFlow.apiEndpoint`,
              rules: "required",
              opts: {
                style: 'float-label'
              }
            },
            {
              col: 6,
              name: "apiAuthheader",
              value: "",
              type: "text",
              label: `admFlow.apiAuthHeader`,
              opts: {
                style: 'float-label'
              }
            },
            {
              col: 6,
              name: "apiAuthKey",
              value: "",
              type: "text",
              label: `admFlow.apiAuthKey`,
              opts: {
                style: 'float-label'
              }
            },
            {
              col: 12,
              name: "apiBody",
              value: "",
              type: "textarea",
              label: `admFlow.apiBody`,
              opts: {
                style: 'float-label',
                rows: 3
              },
              renderIf: ctx => ["POST", "PATCH"].includes(ctx.state.apiMethod)
            },
            {
              col: 12,
              name: "apiResponseMap",
              value: "",
              type: "textarea",
              label: `admFlow.apiResponseMap`,
              rules: "required",
              opts: {
                style: 'float-label',
                rows: 3
              }
            }
          ]
        },
        {
          col: 6,
          name: "fieldType",
          value: "",
          type: "text",
          label: `${M}fieldType`,
          opts: {
            style: 'float-label',
          }
        },
        {
          col: 6,
          name: "affects",
          value: "",
          type: "text",
          label: `${M}affects`,
          opts: {
            style: 'float-label'
          }
        }
      ]
    },

    columns: [
      {
        Header: "",
        accessor: "name",
        type: "html",
        cell: (props) => {
          return <div>
            <div className="text-one truncate">{props.original.name}</div>
            <div className="text-muted text-small">{props.original.ID} - {props.original.type}</div>
          </div>
        },
        minWidth: 200
      },
      {
        Header: "",
        accessor: "required",
        type: "chip",
        chips: {
          true: { text: "Required", color: "orange" },
          false: { text: "Optional", color: "gray" }
        }
      },
      {
        Header: "",
        accessor: "inactive",
        type: "chip",
        chips: {
          true: { text: "Inactive", color: "orange" },
          false: { text: "Active", color: "lightgreen" }
        }
      },
      {
        Header: "",
        accessor: "hidden",
        type: "chip",
        chips: {
          true: { text: "Hidden", color: "orange" },
          false: { text: "Visible", color: "lightgreen" }
        }
      }
    ],

    extras: {
      itemsInRowsTable: [
        {
          icon: 'simple-icon-arrow-up-circle',
          name: 'Move Up',
          onClick: (rowData, ctx) => {
            ctx.moveFlowInput(rowData, 'up')
          }
        },
        {
          icon: 'simple-icon-arrow-down-circle', 
          name: 'Move Down',
          onClick: (rowData, ctx) => {
            ctx.moveFlowInput(rowData, 'down')
          }
        }
      ]
    }
  }
}